/* Horizontal card rows ([data-row]): the arrow buttons scroll the row by about one card; an arrow dims when there is nothing
   more to scroll to. Swiping / trackpad scrolling works natively. Vanilla JS. */
(function () {
  'use strict';

  function init(root) {
    if (root.__row) return;
    root.__row = true;
    var track = root.querySelector('[data-row-track]');
    var prev = root.querySelector('[data-row-prev]');
    var next = root.querySelector('[data-row-next]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    }
    function by(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    /* Finest timepieces (.sig__row), Shop by price (.sbp__row) and Experience the world of Benling (.insta__row): the row moves left by one card every two seconds, in an endless loop.
       Copies of the cards are added after the real ones; when the row has moved past the real cards it jumps back unseen.
       It pauses while the pointer or keyboard focus is on it, while it is off screen and for a moment after you scroll it
       yourself, and it does not run when the visitor prefers reduced motion. */
    if ((root.classList.contains('sig__row') || root.classList.contains('sbp__row') || root.classList.contains('insta__row')) && !reduce && track.children.length > 1) {
      var originals = Array.prototype.slice.call(track.children);
      originals.forEach(function (li) {
        var copy = li.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        Array.prototype.forEach.call(copy.querySelectorAll('a, button'), function (n) { n.setAttribute('tabindex', '-1'); });
        Array.prototype.forEach.call(copy.querySelectorAll('video'), function (v) { v.muted = true; v.setAttribute('autoplay', ''); });
        track.appendChild(copy);
      });
      var hovering = false, focused = false, visible = true, pauseUntil = 0, gliding = false;
      var setWidth = function () { return track.children[originals.length].offsetLeft - track.children[0].offsetLeft; };
      var jumpBack = function () {
        if (gliding) return;
        var w = setWidth();
        if (w > 0 && track.scrollLeft >= w - 2) {
          var snap = track.style.scrollSnapType;
          track.style.scrollSnapType = 'none';
          track.scrollLeft -= w;
          window.requestAnimationFrame(function () { track.style.scrollSnapType = snap; });
        }
      };
      /* One smooth move of one card: quick at the start, easing out gently to a stop (ease-out), about a second long. */
      var glide = function (dist, ms) {
        var start = track.scrollLeft, t0 = null, snap = track.style.scrollSnapType;
        gliding = true;
        track.style.scrollSnapType = 'none';
        var frame = function (t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / ms);
          var eased = 1 - Math.pow(1 - p, 3);
          track.scrollLeft = start + dist * eased;
          if (p < 1) { window.requestAnimationFrame(frame); }
          else { track.style.scrollSnapType = snap; gliding = false; jumpBack(); }
        };
        window.requestAnimationFrame(frame);
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(jumpBack); }, { passive: true });
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
      root.addEventListener('pointerleave', function () { hovering = false; });
      root.addEventListener('focusin', function () { focused = true; });
      root.addEventListener('focusout', function () { focused = false; });
      ['touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { pauseUntil = Date.now() + 3000; }, { passive: true }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
      }
      window.setInterval(function () {
        if (hovering || focused || !visible || document.hidden || gliding || Date.now() < pauseUntil) return;
        var dist = step();
        glide(dist, 1100);
      }, 2000);
    }

    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-row]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
